<template>
  <section>
    <v-flex pa-4>
      <h2>Testimonials List</h2>
    </v-flex>
    <v-dialog persistent v-model="modalWindow" max-width="800">
      <v-btn color="primary" dark slot="activator" class="mb-2" @click="addTestimonials">
        Add Testimonials
      </v-btn>
      <testimonials-form
        v-if="modalWindow"
        @close="closeForm"
        :isNewTestimonials="isNewTestimonials"
        :testimonialObject="testimonialsForm"
      />
    </v-dialog>
    <table-of-testimonials />
  </section>
</template>

<script>
import TestimonialsForm from './testimonialsForm'
import tableOfTestimonials from './tableOfTestimonials'
import { mapActions } from 'vuex'
import { clone } from 'ramda'

export default {
  name: 'TestimonialsList',
  components: {
    TestimonialsForm,
    tableOfTestimonials
  },
  data () {
    return {
      modalWindow: false,
      isNewTestimonials: true,
      testimonialsForm: {},
      defaultTestimonialsForm: {
        employeeName: '',
        companyName: '',
        jobTitle: '',
        testimonialTypeId: '',
        testimonialBody: '',
        youtubeVideoCode: '',
        galleryItemId: ''
      },
    }
  },
  methods: {
    ...mapActions([
      'fetchTestimonialTypes'
    ]),
    addTestimonials () {
      this.isNewTestimonials = true
      this.testimonialsForm = clone(this.defaultTestimonialsForm)
      this.modalWindow = true
    },
    editTestimonial (testimonial) {
      this.isNewTestimonials = false
      this.testimonialsForm = clone(testimonial)
      this.modalWindow = true
    },
    closeForm () {
      this.modalWindow = false
    },
    async getTestimonialTypes () {
      await this.fetchTestimonialTypes()
    }
  },
  mounted() {
    this.getTestimonialTypes()
    this.$bus.$on('onUpdateTestimonial', this.editTestimonial)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Testimonials/TestimonialsList/index.vue